import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    kicker: "The Commission",
    title: "You do not want a photographer. You want an operator.",
    body:
      "Someone who understands scope, timing, discretion and outcome. Someone you can hand a vision to and receive back — refined, resolved, more itself than you thought possible. That is the entire contract.",
  },
  {
    n: "02",
    kicker: "The Method",
    title: "Cinema first. Frames second. Ego never.",
    body:
      "Every shoot is engineered like a small film — call sheets, light plots, backup bodies, redundancy on cards. The look is dictated by the story, not the trend cycle. Nothing here is accidental.",
  },
  {
    n: "03",
    kicker: "The Delivery",
    title: "Private galleries. Colour-graded masters. Zero friction.",
    body:
      "High-res delivery through ShootProof private galleries. Video review through Frame.io. Masters via Dropbox and Google Drive. Invoicing through Wave. You never chase a file, and you never chase a reply.",
  },
];

export default function ManifestoChapters() {
  return (
    <section
      className="relative bg-[var(--bg)] py-20 md:py-28 border-t border-white/5"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.9 }}
          className="mb-14 md:mb-18 max-w-3xl"
        >
          <div className="h-eyebrow mb-6">§ Manifesto</div>
          <h2 className="h-display text-4xl md:text-6xl leading-[0.95]">
            Three principles the studio<br/>
            <span className="italic font-serif-editorial text-[var(--gold)] font-light">refuses to break.</span>
          </h2>
        </motion.div>

        <div className="space-y-16 md:space-y-20">
          {chapters.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.9, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-white/5 pt-10 md:pt-14"
              data-testid={`chapter-${c.n}`}
            >
              <div className="md:col-span-3">
                <div className="numeral text-[8rem] md:text-[11rem] leading-none">{c.n}</div>
                <div className="h-eyebrow mt-3">{c.kicker}</div>
              </div>
              <div className="md:col-span-6">
                <h3 className="h-display text-3xl md:text-5xl leading-[1.05]">{c.title}</h3>
              </div>
              <div className="md:col-span-3">
                <p className="font-serif-editorial text-lg md:text-xl leading-relaxed text-[var(--ink)]/75">
                  {c.body}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
